import { render } from "./SplashScreen.vue?vue&type=template&id=5c1833fe&scoped=true"
const script = {}

import "./SplashScreen.vue?vue&type=style&index=0&id=5c1833fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1833fe"]])

export default __exports__